module.exports = __webpack_public_path__ + "img/hamburger-circle-48px.8930201.svg";